import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { Line } from '../../models/line.model';
import { Api } from "../util/api";

@Injectable()
export class LinesService {
  private endpoint: string = 'lines';

  constructor(private api: Api) {
  }

  public getLines(): Observable<Line[]> {
    return this.api.get(`${this.endpoint}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/data/lines.service.ts